import { t } from '../../../../../../infra/i18n';
export var getNewClientsDescription = function () { return t('engage:campaign_builder.audience.new_clients_description'); };
export var getRegularClientsDescription = function () { return t('engage:campaign_builder.audience.regular_clients_description'); };
export var getLapsedClientsDescription = function () { return t('engage:campaign_builder.audience.lapsed_clients_description'); };
export var getProspectiveClientsDescription = function () {
    return t('engage:campaign_builder.audience.prospective_clients_description');
};
export var AudienceOptions;
(function (AudienceOptions) {
    AudienceOptions["ALL_CLIENTS"] = "All clients";
    AudienceOptions["CUSTOM"] = "Custom";
})(AudienceOptions || (AudienceOptions = {}));
export var ClientsCategories;
(function (ClientsCategories) {
    ClientsCategories["DEFAULT_CLIENTS"] = "Default segments";
    ClientsCategories["CLIENTS_BY_SERVICE"] = "Clients by service";
    ClientsCategories["BARBERS_CLIENTS"] = "Barbers' clients";
    ClientsCategories["SHOPS_CLIENTS"] = "Shops' clients";
})(ClientsCategories || (ClientsCategories = {}));
export var getClientsCategoryLabel = function (category) {
    switch (category) {
        case ClientsCategories.DEFAULT_CLIENTS:
            return t('engage:campaign_builder.audience.default_segments');
        case ClientsCategories.CLIENTS_BY_SERVICE:
            return t('engage:campaign_builder.audience.clients_by_service');
        case ClientsCategories.BARBERS_CLIENTS:
            return t('engage:campaign_builder.audience.barbers_clients');
        case ClientsCategories.SHOPS_CLIENTS:
            return t('engage:campaign_builder.audience.shops_clients');
        default:
            return String(category);
    }
};
export var getNewCustomerWeeksOptions = function () { return [
    { label: t('engage:campaign_builder.audience.weeks_ago', { count: 1 }), value: '1' },
    { label: t('engage:campaign_builder.audience.weeks_ago', { count: 2 }), value: '2' },
    { label: t('engage:campaign_builder.audience.weeks_ago', { count: 3 }), value: '3' },
    { label: t('engage:campaign_builder.audience.weeks_ago', { count: 4 }), value: '4' },
    { label: t('engage:campaign_builder.audience.weeks_ago', { count: 5 }), value: '5' },
    { label: t('engage:campaign_builder.audience.weeks_ago', { count: 6 }), value: '6' },
]; };
